<template>
    <v-app id="inspire">
        <v-navigation-drawer width="290" v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
            <v-list nav dense>
                <v-list-item v-ripple router to="/">
                    <v-list-item-action>
                        <v-icon>home</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Portal Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <template v-for="item in navItemsFiltered()">
                    <template v-if="item.subitems">
                        <!-- TODO: something funny here, v-list-group is a 1.5x concept in vuetify -->
                        <v-list-group :key="item.title" no-action>
                            <template #activator>
                                <v-list-item-action>
                                    <v-icon>{{ item.action }}</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.title" />
                                </v-list-item-content>
                            </template>
                            <template v-for="subItem in item.subitems">
                                <v-list-item :key="subItem.title" v-ripple router :to="subItem.routeto">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="subItem.title" />
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list-group>
                    </template>
                    <template v-else>
                        <v-list-item :key="item.title" v-ripple router :to="item.routeto">
                            <v-list-item-action>
                                <v-icon>{{ item.action }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                </template>
            </v-list>
            <v-list dense>
                <v-list-item v-ripple @click="togglelogin()">
                    <v-list-item-action>
                        <v-icon v-if="!isAuthenticated">
                            mdi-key
                        </v-icon>
                        <v-icon v-else>
                            exit_to_app
                        </v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title v-if="!isAuthenticated">
                            Log In
                        </v-list-item-title>
                        <v-list-item-title v-else>
                            Log Out
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-spacer />
            <v-list dense v-if="isAuthenticated">
                <v-list-item v-ripple @click="gotov1portal()">
                    <v-list-item-action>
                        <v-icon>mdi-open-in-new</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Goto Original Portal</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#54318F" dark>
            <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
                <span class="hidden-sm-and-down">QGistix Portal</span>
            </v-toolbar-title>
            <template v-if="isAuthenticated">
                <span style="margin-right:10px;">Selected Program:</span>
                <v-menu offset-x bottom origin="center center" transition="scale-transition">
                    <template #activator="{ on }">
                        <v-btn small tile light v-on="on" class="text-left" width="180px">
                            {{ program.title }}
                        </v-btn>
                    </template>
                    <v-list dense>
                        <v-list-item v-for="(item, index) in programitems" :key="index" @click="$store.commit('setProgram', item)">
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>

            <v-spacer />

            <template v-if="isQGistix999">
                <v-autocomplete
                    ref="clientid"
                    :items="clients"
                    item-text="client_display_name"
                    item-value="client_id"
                    v-model="client"
                    return-object
                    dense
                    menu-props="{ closeOnClick:true, closeOnContentClick:true, maxHeight:400, transition:scale-transition }"
                    @change="$refs.clientid.blur()"
                    style="margin-top: 20px"
                    placeholder="Please select a client" />
            </template>
            <template v-else>
                <span v-if="isAuthenticated">Client: {{ client.client_name }}</span>
            </template>

            <div class="flex-grow-1" />
            <v-tooltip bottom v-if="isAuthenticated">
                <template #activator="{ on }">
                    <span style="padding-right: 20px;" v-on="on">{{ realname }}</span>
                </template>
                <span>Username: {{ $store.state.auth.profile.preferred_username }}</span>
                <br>
                <span>Email: {{ $store.state.auth.profile.email }}</span>
                <br>
                <span>Role: {{ $store.state.auth.profile["custom:role"] }}</span>
                <br>
                <span>Client: {{ $store.state.auth.profile["custom:client_id"] }}</span>
                <br>
                <span v-if="hasBrid">Branch: {{ $store.state.auth.profile["custom:brid"] }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="isAuthenticated">
                <template #activator="{ on }">
                    <a href="http://qgistix.com" v-on="on">
                        <img src="./assets/qg-logo_trans-1a.png" height="60px">
                    </a>
                </template>
                <span>Go to QGistix.com</span>
            </v-tooltip>
        </v-app-bar>
        <v-main>
            <v-container fill-height>
                <v-snackbar top :timeout="2000" v-model="snackbar">
                    <span>{{ snackbarmsg }}</span>
                    <v-btn text color="teal" @click.native="snackbar = false">
                        Close
                    </v-btn>
                </v-snackbar>
                <router-view />
                <app-chpwd :dialog="pwdialog" :expired="pwexpired" @close="pwdialog = false" />
            </v-container>
        </v-main>
        <v-footer app fixed>
            <span style="color:#54318F;">&copy; QGistix, LLC 2018-Present All Rights Reserved</span>
            <v-spacer />
            <v-menu offset-y>
                <template #activator="{ on }">
                    <v-btn icon v-on="on">
                        <v-icon color="grey darken-3">
                            settings
                        </v-icon>
                    </v-btn>
                </template>
                <v-list dense>
                    <v-list-item
                        v-ripple
                        @click="
                            pwexpired = false;
                            pwdialog = true;
                        "
                        v-if="isTycoBranch">
                        <v-list-item-content>
                            <v-list-item-subtitle>Change Password</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-ripple router to="/pwdchange" v-else-if="isAuthenticated">
                        <v-list-item-content>
                            <v-list-item-subtitle>Change Password</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="refreshauth">
                        <v-list-item-content>
                            <v-list-item-subtitle>Refresh Auth</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="clearconfirmdialog = true">
                        <v-list-item-content>
                            <v-list-item-subtitle>Clear All Settings</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-dialog v-model="clearconfirmdialog" persistent max-width="390">
                <v-card>
                    <v-card-title class="headline">
                        Clear all application settings?
                    </v-card-title>
                    <v-card-text>
                        This will clear all application settings, such as selected progam and favorite reports, and log you out.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn text @click.native="clearconfirmdialog = false">
                            Cancel
                        </v-btn>
                        <v-btn
                            text
                            @click.native="
                                clearconfirmdialog = false;
                                clearsettings();
                            ">
                            Ok
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-footer>
    </v-app>
</template>

<script>
import config from "./config";
import chpwd from "./views/chpwd.vue";
import axios from "axios";

export default {
    components: { "app-chpwd": chpwd },
    data: () => ({
        clearconfirmdialog: false,
        drawer: null,
        navitems: [
            // FWD only, only for branch users
            {
                program: "FWD",
                action: "mdi-truck-fast-outline",
                title: "Print Shipping Label",
                role: "branch",
                routeto: "/rmalabel",
            },
            // FWD,REM
            {
                program: "FWD,REM",
                action: "mdi-warehouse",
                title: "Warehouse & Inventory",
                role: "manager,employee,client",
                subitems: [{
                    program: "FWD,REM",
                    title: "By Part and Part History",
                    routeto: "/report/warehouse_inventory_drillthrough",
                    equivalentroutes: "/report/warehouse_inventory_rev",
                },
                {
                    program: "FWD",
                    ff: "FF_ORDERFORM",
                    title: "Order Form",
                    routeto: "/order/3pl",
                },
                {
                    program: "FWD",
                    ff: "FF_LEGACY_CSVORDERFORM",
                    title: "CSV Order Form",
                    routeto: "/csvorder",
                },
                {
                    program: "FWD,REM",
                    title: "Cycle Count Summary",
                    routeto: "/report/warehouse_inventory_cycle_count_summary",
                },
                {
                    program: "FWD,REM",
                    title: "Cycle Count Details",
                    routeto: "/report/warehouse_inventory_cycle_count_details",
                },
                {
                    program: "FWD",
                    // ff: "FF_RPT_AuditObs",
                    title: "Audit Observations",
                    routeto: "/customReport/auditObservations",
                }],
            },
            // REV only, top level part pipeline
            {
                program: "REV",
                action: "mdi-cog-outline",
                ff: "FF_RPT_PDSync",
                title: "Part Pipeline",
                subitems: [{
                    program: "REV",
                    title: "Part Pipeline Summary",
                    routeto: "/report/rev_part_summary",
                },
                {
                    program: "REV",
                    title: "Part Pipeline Details",
                    routeto: "/report/rev_part_details",
                }],
            },
            // REV only, only for branch users
            {
                program: "REV",
                action: "mdi-warehouse",
                title: "Order Form",
                role: "branch",
                routeto: "/order/rev",
            },
            {
                program: "REV",
                action: "mdi-truck-delivery",
                title: "Receiving",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Advance Shipment Notifications",
                    routeto: "/report/receiving_rev_advance_shipment_notifications",
                },
                {
                    program: "REV",
                    title: "Show All Received Shipments",
                    routeto: "/report/receiving_rev_show_all_shipments",
                },
                {
                    program: "REV",
                    title: "Receiving Details",
                    routeto: "/report/receiving_rev_details",
                },
                {
                    program: "REV",
                    title: "Receiving Branch Summary",
                    routeto: "/report/receiving_rev_branch_summary",
                },
                {
                    program: "REV",
                    title: "Branch Compliance",
                    routeto: "/report/receiving_rev_branch_compliance",
                },
                {
                    program: "REV",
                    title: "Flagged Boxes",
                    routeto: "/native_report/rev/flagged_boxes",
                }],
            },
            {
                program: "REV",
                action: "mdi-clipboard-list-outline",
                title: "Sorting & Cataloging",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Show All Parts",
                    routeto: "/report/cataloging_show_all_parts",
                },
                {
                    program: "REV",
                    title: "Branch Compliance",
                    routeto: "/customReport/branchCompliance",
                },
                {
                    program: "REV",
                    ff: "FF_RPT_PDAsync",
                    title: "Part Detail",
                    routeto: "/customReport/partDetails",
                },
                {
                    program: "REV",
                    title: "Cycle Time",
                    routeto: "/report/cataloging_reverse_logistics_cycle_time",
                },
                {
                    program: "REV",
                    title: "Disposition Summary",
                    routeto: "/report/reverse_logistics_disposition_summary",
                },
                {
                    program: "REV",
                    title: "Repeat CR Returns",
                    routeto: "/report/reverse_logistics_repeat_cr_returns",
                }],
            },
            // REV only, ADT CDR
            {
                program: "REV",
                action: "mdi-home-city",
                ff: "FF_RPT_CDR",
                title: "Customer Direct Returns",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "RMA Status Overview",
                    routeto: "/report/cdr_rmasummary",
                },
                {
                    program: "REV",
                    title: "Closed RMA Summary",
                    routeto: "/report/cdr_closedrmasummary",
                },
                {
                    program: "REV",
                    title: "Closed RMA Detail",
                    routeto: "/report/cdr_closedrmadetail",
                },
                {
                    program: "REV",
                    title: "CDR Pipeline",
                    ff: "FF_RPT_CDR_PIPE",
                    routeto: "/customReport/cdrPipeline",
                }],
            },
            {
                program: "REV",
                action: "mdi-clipboard-check",
                title: "Testing",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Detail Report",
                    ff: "FF_RPT_TDAsync",
                    routeto: "/customReport/testingDetail",
                },
                {
                    program: "REV",
                    title: "Detail Report",
                    ff: "FF_RPT_TDSync",
                    routeto: "/report/testing_detail_report",
                }],
            },
            {
                program: "REV",
                action: "mdi-warehouse",
                title: "Warehouse & Inventory",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    role: "manager",
                    title: "Details",
                    routeto: "/report/warehouse_inventory_details",
                },
                {
                    program: "REV",
                    role: "manager,employee,client",
                    title: "Finished Goods",
                    routeto: "/report/finished_goods",
                },
                {
                    program: "REV",
                    ff: "FF_ORDERFORM",
                    title: "Order Form",
                    routeto: "/order/rev",
                },
                {
                    program: "REV",
                    role: "manager,employee,client",
                    ff: "FF_LEGACY_CSVORDERFORM",
                    title: "CSV Order Form",
                    routeto: "/csvorder",
                }],
            },
            {
                program: "REV",
                action: "mdi-truck-fast",
                title: "Shipping",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Completed Shipments",
                    routeto: "/report/shipping_completed_shipments",
                },
                {
                    program: "REV",
                    title: "Return to Customer",
                    routeto: "/report/shipping_return_shipments",
                    ff: "FF_RPT_SHPRTN",
                },
                {
                    program: "REV",
                    title: "Open Orders",
                    routeto: "/report/shipping_open_orders",
                }],
            },
            {
                program: "REV",
                action: "mdi-package-down",
                title: "RMA to Manufacturer",
                role: "manager,employee,client",
                //ff: "FF_RPT_RMAMFG",
                subitems: [{
                    program: "REV",
                    title: "All RMAs",
                    routeto: "/report/rma_to_manufacturer_all_active_rma",
                },
                {
                    program: "REV",
                    title: "Warranty Return Part Queue",
                    routeto: "/customReport/warrantyReturnPartQueue",
                },
                {
                    program: "REV",
                    title: "Warranty Return Aging",
                    routeto: "/report/reverse_logistics_warranty_return_aging",
                },
                {
                    program: "REV",
                    title: "Warranty Return Valuation",
                    routeto: "/customReport/warrantyReturnValuation",
                },
                {
                    program: "REV",
                    title: "Warranty Return Valuation By MFG",
                    routeto: "/report/reverse_logistics_warranty_return_valuation_mfg",
                }],
            },
            {
                program: "REV",
                action: "mdi-package-down",
                title: "RMA to QGistix",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Summary",
                    routeto: "/report/rma_to_qgistix",
                },
                {
                    program: "REV",
                    title: "Details",
                    routeto: "/report/rma_to_qgistix_details",
                }],
            },
            //End Of Rev only
            // FWD,REM
            {
                program: "FWD,REM",
                action: "mdi-truck-delivery",
                title: "Inbound Stock",
                role: "manager,employee,client",
                subitems: [{
                    program: "FWD",
                    title: "Receiving Summary",
                    routeto: "/report/receiving_summary",
                    ff: "FF_RPT_RCVINV",
                },
                {
                    program: "FWD,REM",
                    title: "Inbound Stock Summary",
                    routeto: "/report/inbound_stock_summary",
                },
                {
                    program: "FWD,REM",
                    title: "Inbound Stock Details",
                    routeto: "/report/inbound_stock_details",
                },
                {
                    program: "FWD,REM",
                    title: "Inbound Shipments",
                    routeto: "/report/inbound_shipments",
                }],
            },
            {
                program: "FWD,REM",
                action: "receipt",
                title: "Active Orders",
                role: "manager,employee,client",
                subitems: [{
                    program: "FWD,REM",
                    title: "Summary",
                    routeto: "/report/active_orders_summary",
                },
                {
                    program: "FWD,REM",
                    title: "Details",
                    routeto: "/report/active_orders_details",
                }],
            },
            {
                program: "FWD,REM",
                action: "mdi-truck-fast",
                title: "Shipping",
                role: "manager,employee,client",
                subitems: [
                    // {
                    //   program: "FWD,REM",
                    //   title: "Completed Shipments",
                    //   routeto: "/report/completed_shipments"
                    // },
                    {
                        program: "FWD,REM",
                        title: "Shipping",
                        routeto: "/report/shipping_shipping",
                    },
                    {
                        program: "FWD,REM",
                        title: "Performance",
                        routeto: "/report/shipping_performance",
                    },
                    {
                        program: "FWD,REM",
                        title: "Performance (>30 days)",
                        routeto: "/customReport/shippingPerformance",
                        ff: "FF_RPT_ASYNCSHIPPERF",
                    }],
            },
            {
                program: "FWD",
                action: "mdi-receipt",
                title: "Billing",
                role: "manager,client",
                ff: "FF_RPT_BILLING",
                subitems: [{
                    program: "FWD",
                    title: "Billing Details Outbound",
                    routeto: "/report/fwd_billing_details_outbound",
                }],
            },
            {
                program: "REV",
                action: "mdi-phone-return",
                title: "Recall",
                role: "manager,employee,client",
                subitems: [{
                    program: "REV",
                    title: "Summary",
                    routeto: "/report/recall_summary",
                },
                {
                    program: "REV",
                    title: "Details",
                    routeto: "/report/recall_details",
                }],
            },
            {
                program: "FWD,REV,REM",
                action: "mdi-chart-areaspline",
                title: "Management Reports",
                role: "manager,employee",
                subitems: [{
                    program: "FWD,REV,REM",
                    title: "Shredded HDD Details",
                    routeto: "/report/shredded_hdd_details",
                }],
            },
            // {
            //   program: "REV",
            //   action: "mdi-harddisk ",
            //   title: "Certificate of Destruction",
            //   role: "manager,employee,client",
            //   routeto: "/cod",
            // },
        ],
        pwexpired: false,
        pwdialog: false,
        snackbarmsg: "",
        snackbar: false,
        recalcclients: 0,
    }),
    computed: {
        isAuthenticated() 
        {
            return this.$store.state.auth.isAuthenticated;
        },
        isQGistix999() 
        {
            if (this.$store.state.auth.isAuthenticated) {return this.$store.state.auth.profile["custom:client_id"] == "999";}
            else {return false;}
        },
        isManager() 
        {
            if (this.$store.state.auth.isAuthenticated) {return this.$store.state.auth.profile["custom:role"] == "manager";}
            else {return false;}
        },
        isTycoBranch() 
        {
            if (this.$store.state.auth.isAuthenticated)
            {
                return (
                    this.$store.state.auth.profile["custom:client_id"] == "102" &&
          this.$store.state.auth.profile["custom:role"] == "branch" &&
          this.$store.state.auth.profile.email.match(/branch\d+@jci.com/gi)
                );
            }
            else {return false;}
        },
        idToken() 
        {
            return this.$store.state.auth.idToken;
        },
        realname() 
        {
            if (this.$store.state.auth.isAuthenticated) {return this.$store.state.auth.profile.given_name + " " + this.$store.state.auth.profile.family_name;}
            else {return "";}
        },
        stationid() 
        {
            if (this.$store.state.auth.isAuthenticated) {return this.$store.state.auth.stationId;}
            else {return "";}
        },
        hasBrid() 
        {
            if (this.$store.state.auth.isAuthenticated) {return this.$store.state.auth.profile["custom:brid"] ? true : false;}
            else {return false;}
        },
        programitems() 
        {
            if (this.$store.state.auth.profile["custom:client_id"] == "171") 
            {
                return [{ title: "Reverse Logistics", value: "REV" }, { title: "Forward Logistics", value: "FWD" }];
            }
            return [{ title: "Reverse Logistics", value: "REV" },
                { title: "Forward Logistics", value: "FWD" },
                { title: "Remarketing", value: "REM" }]
        },
        program() 
        {
            if (this.$store.state.portalsettings.program) {return this.$store.state.portalsettings.program;}
            else {return { title: "Select Program", value: "NA" }}
        },
        client: {
            get: function() 
            {
                // if a 999 user, we return the selected client or a placeholder
                if (this.isQGistix999) 
                {
                    if (this.$store.state.portalsettings.client) {return this.$store.state.portalsettings.client;}
                    else {return { client_name: "Select Client", client_id: "" };}
                }

                // otherwise we return the client object for the authenticated user's client
                let client_info;
                if (this.$store.state.auth.profile) 
                {
                    let users_client_id = this.$store.state.auth.profile["custom:client_id"];
                    if (this.clients && this.clients.length) 
                    {
                        client_info = this.clients.find((c) => c.client_id == users_client_id);
                    }
                }
                return client_info ? client_info : { client_name: "", client_id: "", client_display_name: "" };
            },
            set: function(client) 
            {
                console.log("client set: " + JSON.stringify(client));
                this.$store.commit("setClient", client);
            },
        },
        domainroot() 
        {
            return window.location.hostname
                .split(".")
                .reverse()
                .splice(0, 2)
                .reverse()
                .join(".");
        },
    },
    asyncComputed: {
        clients: {
            lazy: true, // this gives the page time to get isAuthenticated calculated before we try to get clients
            async get() 
            {
                try 
                {
                    if (this.$store.state.auth.isAuthenticated) 
                    {
                        let response = await axios.get(config.QDS + "clients", { headers: { Authorization: this.idToken } });

                        return response.data.map((c) => 
                        {
                            c.client_display_name = c.client_name + " - " + c.client_id;
                            return c;
                        });
                    }
                }
                catch (e) 
                {
                    return [];
                }
            },
            watch: ["recalcclients"],
            default: [],
        },
    },
    watch: {
        async isAuthenticated(newauth, oldauth) 
        {
            if (newauth) 
            {
                // pick default program if none is set
                if (
                    !this.$store.state.portalsettings.program ||
          // force recalc when a branch user, this will take care of most cases of different roles
          this.$store.state.auth.profile["custom:role"] == "branch"
                ) 
                {
                    console.log("Picking default program...");
                    let client_id = this.$store.state.auth.profile["custom:client_id"];
                    if (["102", "116", "144", "146", "147"].includes(client_id)) {this.$store.commit("setProgram", this.programitems.find((p) => p.value == "FWD"));}
                    else {this.$store.commit("setProgram", this.programitems.find((p) => p.value == "REV"));}
                }
                // TODO: there is a possible bug when switching users with different roles/programs in more complicated cases

                this.recalcclients += 1;

                let response = await axios.get(config.QUS + "portal/user/" + encodeURIComponent(this.$store.state.auth.profile.email), { headers: { Authorization: this.idToken } });

                if (response.data[0]) 
                {
                    if (response.data[0].expired) 
                    {
                        console.log("Password expired, showing password change dialog...");
                        // user's password has expired, show expired page
                        if (this.isTycoBranch) 
                        {
                            this.pwexpired = true;
                            this.pwdialog = true;
                        }
                        else 
                        {
                            this.$router.push("/expired");
                        }
                    }
                    else 
                    {
                        console.log("Password not expired");
                    }
                }
                else 
                {
                    console.error("Error - no QDS data for this user!");
                }
            }

            this.setLegacyCookies();
        },
        idToken() 
        {
            // when we get a new id token we refresh the client list
            // this works better that isAuthenticated becasue it picks up changes when the
            // user has been logged in past the id token valid time (1 hour) but before the
            // refresh token expiration (1 day)
            console.log("new id token detected, updating...");
            this.setLegacyCookies();
            this.recalcclients += 1;
        },
        client(newclient) 
        {
            if (newclient && newclient.client_id) 
            {
                // we keep the legacy cookie up-to-date with the selected client (999 users can select a client)
                this.$cookies.set("qgclient", newclient.client_id, 0, "/", this.domainroot);
            }
        },
        program(newprogram, oldprogram) 
        {
            // we keep the legacy cookie up-to-date with the selected program
            this.$cookies.set("qgprogram", newprogram.value, 0, "/", this.domainroot);

            // on a program change we try to select an equivalent if needed and if possible
            // console.log(`Program changed from ${oldprogram.value} to ${newprogram.value}`)
            // console.log(`current route is: ${this.$route.path}`)

            // find if our current route is a report
            if (this.$route.name == "report") 
            {
                // if our subitem is for both the from and to programs it's a NOP
                let current_navitem;
                for (const ni of this.navItemsFiltered(false)) 
                {
                    if (ni.routeto == this.$route.path) 
                    {
                        current_navitem = { program: ni.program, routeto: ni.routeto };
                        break;
                    }
                    else if (ni.subitems) 
                    {
                        // check subitems
                        for (const si of ni.subitems) 
                        {
                            if (si.routeto == this.$route.path) 
                            {
                                current_navitem = { program: si.program, routeto: si.routeto };
                                break;
                            }
                        }
                    }
                }

                // console.log(`current_navitem: ${JSON.stringify(current_navitem)}`)
                if (current_navitem && current_navitem.program.split(",").includes(newprogram.value)) {return;} // our current page handles the new program, we bail out

                // now we map-reduce our way to an equivalent, if any:
                let equivalent = this.navItemsFiltered(false)
                    .filter((ni) => ni.subitems) // only consider nav items (ni) with subitems
                    .reduce((accum, ni) => 
                        [...accum,
                            ...ni.subitems.reduce((accum_si_withequivalents, si) => 
                            {
                                if (si.equivalentroutes) {accum_si_withequivalents.push(si);} // only consider subitems with equivalent routes
                                return accum_si_withequivalents;
                            }, [])], [])
                // now we filter by possibilities that have an equivalent route with the program we are switching to
                    .filter(
                        (si_with_equiv) =>
                            si_with_equiv.equivalentroutes.split(",").includes(this.$route.path) && si_with_equiv.program.split(",").includes(newprogram.value),
                    );

                console.log(`equivalent: ${JSON.stringify(equivalent)}`);
                if (equivalent.length) 
                {
                    this.$router.push({ path: equivalent[0].routeto }); // we pick 1st equivalent
                    return;
                }
            }

            // default is to go to the home page
            if (this.$route.name != "home") {this.$router.push({ name: "home" });}
        },
    },
    methods: {
        togglelogin() 
        {
            if (this.$store.state.auth.isAuthenticated) {this.$store.dispatch("signOut");}
            else {this.$router.push({ name: "login" });}
        },
        gotov1portal() 
        {
            window.location.assign("https://www.qgistix.com/Portal.html");
        },
        refreshauth() 
        {
            this.$store.dispatch("refreshAuthTokens", true);
        },
        setLegacyCookies() 
        {
            // this is a hack, we set legacy cookies so some code can call code on QX1 and get a response (e.g. packing slip)
            if (this.isAuthenticated) 
            {
                this.$cookies.set("qgbranch", this.$store.state.auth.profile["custom:brid"], 0, "/", this.domainroot);
                this.$cookies.set("qgclient", this.client.client_id, 0, "/", this.domainroot); // grab the computed one so it respects any saved client setting for 999 users
                this.$cookies.set("qgname", this.$store.state.auth.profile.given_name, 0, "/", this.domainroot);
                this.$cookies.set("qgrole", this.$store.state.auth.profile["custom:role"], 0, "/", this.domainroot);
                this.$cookies.set("qguser", this.$store.state.auth.profile.preferred_username, 0, "/", this.domainroot);
                this.$cookies.set("qgprogram", this.program.value, 0, "/", this.domainroot);
            }
            else 
            {
                this.$cookies.remove("qgbranch");
                this.$cookies.remove("qgclient");
                this.$cookies.remove("qgname");
                this.$cookies.remove("qgrole");
                this.$cookies.remove("qguser");
                this.$cookies.remove("qgprogram");
            }
        },
        clearsettings() 
        {
            this.$store.dispatch("signOut");
            window.localStorage.clear();
        },
        navItemsFiltered(filterby_program = true) 
        {
            // passes back filtered list of nav items, filtered by program, user role, and featureflag
            // to not filter by program (used when searching for 'equivalent' reports when changing programs)
            if (this.isAuthenticated && this.$store.state.portalsettings.program) 
            {
                let filtered_navitems = this.navitems.reduce((accum, i) => 
                {
                    // check top-level role and featureflag
                    let rolecheck = true;
                    if (i.role) {rolecheck = i.role.split(",").includes(this.$store.state.auth.profile["custom:role"]);}
                    let ffcheck = true;
                    if (i.ff) {ffcheck = this.$store.state.auth.featureFlags.includes(i.ff);}

                    if (rolecheck && ffcheck) 
                    {
                        let clone = { ...i };

                        if (clone.subitems) 
                        {
                            // now filter subitems by role and featureflag
                            clone.subitems = i.subitems.filter((si) => 
                            {
                                let sirolecheck = true;
                                if (si.role) {sirolecheck = si.role.split(",").includes(this.$store.state.auth.profile["custom:role"]);}
                                let siffcheck = true;
                                if (si.ff) {siffcheck = this.$store.state.auth.featureFlags.includes(si.ff);}
                                return sirolecheck && siffcheck;
                            });
                        }

                        accum.push(clone);
                    }

                    return accum;
                }, []);

                // then by program - Note: program filtering is only for top-level items, not subitems
                if (filterby_program) {return filtered_navitems.filter((i) => i.program.split(",").includes(this.$store.state.portalsettings.program.value));}
                return filtered_navitems;
            }
            return [];
        },
    },
    created() 
    {
        console.log("app created called");

        // check auth every 5 minutes, refresh if needed
        this.timer = setInterval(this.$store.dispatch, 300000, "refreshAuthTokens", false);

        // now we force an auth refresh so the user will be properly logged-in (or out) depending on the validity of their token
        this.$store.dispatch("refreshAuthTokens", true);
    },
    beforeDestroy() {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #54318f;
}
.v-list-item-active {
  color: #54318f;
}
</style>
